import { library } from '@fortawesome/fontawesome-svg-core';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { FocusLoop } from '../../../../components/FocusLoop';
import { IQuestionModel, isAttributeQuestion } from '../../question.model';
import { QuestionWithAnswers } from './QuestionWithAnswers';

interface IQuestionsListProps {
  questions: IQuestionModel[];
  readonly: boolean;
  segmentationId: string | undefined;
  onAnswered: (questionId: string, answer: string) => void;
}

library.add(faClipboardCheck);

export const QuestionsList = observer((props: IQuestionsListProps): ReactElement => {
  const { t } = useTranslator();

  const isAttribute = props.questions.length > 0 && isAttributeQuestion(props.questions[0]);

  return props.questions.length > 0 ? (
    <ColumnLayout
      size='none'
      className={classNames('question-list', { 'annotation-tools-readonly-overlay': props.readonly })}
    >
      <div className='header'>{isAttribute ? t('set_attributes') : t('answer_on_questions')}</div>
      <FocusLoop
        selectors={['input', 'textarea']}
        parentElement='question-list-single-item'
      >
        {props.questions.map((q) => (
          <QuestionWithAnswers
            key={q.id + (props.segmentationId ?? '')}
            question={q}
            disabled={props.readonly}
            isAttribute={isAttribute}
            onAnswered={props.onAnswered}
          />
        ))}
      </FocusLoop>
    </ColumnLayout>
  ) : (
    <></>
  );
});
